import {
  AggregateRatingOriginContent,
  FAQItem,
  RICH_SEARCH_TYPES,
  getFAQRichSearch,
} from "@/utils/richSearch";

const facilitiesFAQData: FAQItem[] = [
  {
    question: "장지 비용이 얼마 정도 발생하나요?",
    answer:
      "장지 비용은 지역, 봉안 시설 및 고인의 상황에 따라 금액적인 차이가 매우 다양합니다. 고이 장례 연구소에서는 고인, 유가족 분들의 상황별로 적합한 장례식장, 장지를 추천해 드리고 있으며 대략적인 비용 견적 또한 받아보실 수 있습니다. 24시간 상담 (1666-9784) <a href='https://goifuneral.co.kr/match/request/?type=facility'>비용 견적 받아보기</a>",
  },
  {
    question: "장지와 장례식장은 서로 다른 건가요?",
    answer:
      "네 맞습니다. 장지와 장례식장은 다른 역할을 하는 공간입니다. 장지의 경우 흔히 말하는 화장장, 봉안당, 수목장 등이 포함되며 장례식장은 고인을 안치시키고 조문객을 받을 수 있는 빈소를 제공하는 곳입니다. 이 두 곳 모두 비용, 접근성 등을 고려해서 선택을 하는 것이 좋으며 이 과정은 다소 복잡할 수 있습니다. 고이 장례 연구소에서는 이러한 전 과정을 유가족 분들과 함께 고민하고 있습니다. 도움이 필요하신 경우 연락 주시길 바랍니다. 24시간 상담 (1666-9784) <a href='https://goifuneral.co.kr/match/request/'>한번에 추천 받기</a>",
  },
  {
    question: "장지(봉안당, 수목장)도 미리 준비할수 있나요?",
    answer:
      "네 장지도 미리 준비가 가능합니다. 고인의 마지막 보금자리가 될 곳인 봉안당(납골당), 수목장의 경우 시설, 거리 등 여러 부분을 고려하여 결정하는 것이 중요합니다. 이 고민 또한 고이 장례 연구소에서는 함께 진행하고 있으므로 언제든지 연락 주시길 바랍니다. 24시간 상담 (1666-9784)  <a href='https://www.goifuneral.co.kr/match/request/?type=facility'>장지 미리 준비하기</a>",
  },
];

const defaultAggregateRatingData: AggregateRatingOriginContent = {
  "@type": RICH_SEARCH_TYPES.AGGREGATE_RATING,
  ratingValue: "4.9",
  bestRating: "5",
  ratingCount: "13",
};

const FAQRichSearch = getFAQRichSearch(facilitiesFAQData);

export const facilitiesRichSearch = {
  FAQRichSearch,
  defaultAggregateRatingData,
};
